import React from 'react';
import PropTypes from 'prop-types';

import { ProductImage } from '../../../common/product-image';
import { AddToCartSection } from '../../../common/add-to-cart-section';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';
import { enforceParameters } from '../../../hocs/enforce-parameters';

import styles from './ProductSummary.css';

const IPropTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    financing: PropTypes.shape({
      priceString: PropTypes.string.isRequired,
    }).isRequired,
    coverImage: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
  }).isRequired,
  mobileVersion: PropTypes.bool,
};

const defaultProps = {
  mobileVersion: false,
};

const ProductSummary = props => (
  <div className={styles.container}>
    <ProductImage
      className={props.mobileVersion ? styles.mobileImage : styles.image}
      size={props.mobileVersion ? 'sm' : 'lg'}
      src={props.product.coverImage}
    />
    <p className={styles.brand}>{props.product.brand}</p>
    <p className={styles.name}>{props.product.name}</p>
    <p className={styles.price}>${props.product.financing.priceString}</p>
    {
      !ConfigParametersStore.showIntranet &&
      <AddToCartSection
        product={props.product}
        className={styles.addToCartSectionContainer}
        buttonText={props.mobileVersion ? 'Agregar' : undefined}
        showText
      />
    }
  </div>
);

ProductSummary.propTypes = IPropTypes;
ProductSummary.defaultProps = defaultProps;

const EnforcedProductSummary = enforceParameters(ProductSummary);

export { EnforcedProductSummary as ProductSummary };



// WEBPACK FOOTER //
// ./src/pages/compare/product-summary/ProductSummary.jsx